export const authFactory = (config) => `Bearer ${config.envJWTToken}`;
export const urlApiFactory = (config) => new URL(config.hostApi);
